import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { vaultStoreActions } from '@app/root-store';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AmplifyHttpClient } from '../auth/http.amplify-httpclient';
import { loaderTypes } from '@app/shared/component/loader/loader';

@Injectable({
  providedIn: 'root',
})
export class CommonService implements OnDestroy {
  monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  private _jsonURL = 'assets/json/relationship.json';

  private _templatecenter_jsonURL = 'assets/json/templatecenter.json';
  private _linkedTemplated_jsonURL = 'assets/json/linkedTemplated.json';
  private _reminderConfig_jsonURL = 'assets/json/reminder_config.json';
  private moveToTrashApi = 'api/common/move-to-trash';
  private restoreFromTrash = 'api/common/restore-from-trash';
  public distributionRegisterToggleSubject: BehaviorSubject<any> = new BehaviorSubject({ data: {}, open: false });

  constructor(private readonly httpService: AmplifyHttpClient, private http: HttpClient, private store: Store) {}

  getStatus() {
    return this.httpService.get<any>(`api/common/state`).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getLanguages() {
    return this.httpService.get<any>(`api/common/language`).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getOrientations() {
    return this.httpService.get<any>(`api/common/orientation`).pipe(
      map((data) => {
        return data;
      })
    );
  }
  getPostDistribution() {
    return this.httpService.get<any>(`api/common/post-distribution`).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getPostType() {
    return this.httpService.get<any>(`api/common/post-type`).pipe(map((data) => {}));
  }

  getGroupsInTrash() {
    const url = `api/common/trash/vault_group`;
    return this.httpService.get<any>(`${url}`).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  getCountries(val) {
    if (val != '') {
      return this.httpService.get<any>(`api/common/country`, { params: val }).pipe(
        map((data) => {
          return data;
        })
      );
    } else {
      return this.httpService.get<any>(`api/common/country`).pipe(
        map((data) => {
          return data;
        })
      );
    }
  }
  getToolTip(request) {
    return this.httpService.get<any>(`api/common/tool-tip`, { params: request }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getRelationahips() {
    return this.httpService.get<any>(`api/common/relationship`).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getRelationahipsResult(request) {
    return this.httpService.post<any>(`api/connection/get_relationship`, { params: request }).pipe(
      map((data) => {
        return data;
      })
    );
  }

  // move to trash
  moveAssetToTrash(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveToTrashChecklistTemplate(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveToTrashVaultFolder(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveToTrashForm(request) {
    return this.httpService.post(this.moveToTrashApi, request, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveToTrashWorkspaceFolder(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveToTrashWorkspace(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveToTrashInformationFolder(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveVaultToTrash(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  moveReportToTrash(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  // restore from trash
  restoreAssetFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreChecklistTemplateFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreVaultFolderFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreFormFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreWorkspaceFolderFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreWorkspaceFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreInformationFolderFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreTaskFromTrash(request): Observable<any> {
    return this.httpService.post<any>(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreVaultFromTrash(request): Observable<any> {
    return this.httpService.post<any>(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  restoreReportFromTrash(request): Observable<any> {
    return this.httpService.post<any>(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  // get from trash
  getVaultFromTrash(): Observable<any> {
    const url = `api/common/trash/vault`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getReportFromTrash(): Observable<any> {
    const url = `api/common/trash/report`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getTaskFromTrash(): Observable<any> {
    const url = `api/common/trash/task`;
    return this.httpService.get<any>(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  getAssetsFromTrash() {
    const url = `api/common/trash/asset`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getChecklistTemplateFromTrash() {
    const url = `api/common/trash/checklist_template`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getWorkspaceFromTrash() {
    const url = `api/common/trash/workspace`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getWorkspaceFolderFromTrash() {
    const url = `api/common/trash/workspace_folder`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getVaultFolderFromTrash() {
    const url = `api/common/trash/vault_folder`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getMyInformationFoldersFromTrash() {
    const url = 'api/common/trash/office_vault_folder';
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  getFormFromTrash() {
    const url = `api/common/trash/form`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  public getReminderConfigJSON(): Observable<any> {
    return this.http.get(this._reminderConfig_jsonURL).pipe(
      map((data) => {
        return data;
      })
    );
  }
  public getLinkedTemplatedJSON(): Observable<any> {
    return this.http.get(this._linkedTemplated_jsonURL).pipe(
      map((data) => {
        return data;
      })
    );
  }

  public getTemplateCenterJSON(): Observable<any> {
    return this.http.get(this._templatecenter_jsonURL).pipe(
      map((data) => {
        return data;
      })
    );
  }

  public getRelationshipJsonFile(): Observable<any> {
    return this.http.get(this._jsonURL).pipe(
      map((data) => {
        return data;
      })
    );
  }

  getCurrentDateFromUnixTimestamp(timestamp) {
    const year = new Date(timestamp * 1000).getUTCFullYear();
    const m = new Date(timestamp * 1000).getUTCMonth() + 1;
    let day = new Date(timestamp * 1000).getUTCDate();
    const month = this.monthNames[m - 1];

    if (day < 10) {
      const newDay = '0' + day;
      day = Number(newDay);
    }
    return `${month} ${day}, ${year}`;
  }

  getCurrentDateInEpoch() {
    const epochDate = ~~(+new Date() / 1000);
    return epochDate;
  }

  getTimeConvertedFromEpoch(timestamp) {
    const date = new Date(timestamp * 1000);
    // Hours part from the timestamp
    const hours = date.getHours();
    // Minutes part from the timestamp
    const minutes = '0' + date.getMinutes();
    // Seconds part from the timestamp
    const seconds = '0' + date.getSeconds();

    // Will display time in 10:30:23 format
    const formattedTime = hours + ':' + minutes.substr(-2);
    return formattedTime;
  }

  eraseCookieFromAllPaths(name) {
    // This function will attempt to remove a cookie from all paths.
    const pathBits = location.pathname.split('/');
    let pathCurrent = ' path=';

    // do a simple pathless delete first.
    document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;';

    for (let i = 0; i < pathBits.length; i++) {
      pathCurrent += (pathCurrent.substr(-1) != '/' ? '/' : '') + pathBits[i];
      document.cookie = name + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT;' + pathCurrent + ';';
    }
  }

  createClientGroup(request) {
    const url = 'api/network/client-group';
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getClientGroup() {
    return of([]);
    // const url = 'api/network/client-group';
    // return this.httpService.get(url).pipe(
    //   map((response: any) => {
    //     if (response.status == 200) {
    //       return response.data;
    //     }
    //   })
    // );
  }

  updateClientGroup(params) {
    const url = 'api/network/client-group';
    return this.httpService.patch<any>(url, params).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  deleteClientGroup(id) {
    const url = `api/network/client-group/${id}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  createClientToClientGroup(request) {
    const url = '/api/network/client-group-clients';
    return this.httpService.post(url, request).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  deleteClientFromClientGroup(groupId, id) {
    const url = `api/network/client-group-clients/${groupId}/${id}`;
    return this.httpService.delete(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }

  getClientFromClientGroup(id) {
    const url = `api/network/client-group-clients/${id}`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }

  udpatesharedByMeData(id, vaultId = null) {
    this.store.dispatch(new vaultStoreActions.UserFoldersSharedByMeRequest(id, true, vaultId));
  }
  getSizeInUnit(filesize) {
    filesize = filesize / 1024;

    const filesizeRounded = Math.round(filesize.toFixed(2));

    if (filesizeRounded > 1000) {
      filesize = Math.round(filesize / 1024) + ' MB';
    } else {
      filesize = filesizeRounded + ' KB';
    }

    return filesize;
  }
  public locationTemplateDataSubject: BehaviorSubject<any> = new BehaviorSubject(undefined);

  public sideNavToggleSubject: BehaviorSubject<any> = new BehaviorSubject(true);
  public toggle(payload) {
    this.sideNavToggleSubject.next(true);
  }

  public updateTransactionCountData: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public updateReportTransactionCountData: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public sideNavToggleSubjectFormSetup: BehaviorSubject<any> = new BehaviorSubject(false);

  public sideNavToggleSubjectLinkTemplate: BehaviorSubject<any> = new BehaviorSubject(false);

  public sideNavToggleSubjectTemplate: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public sideNavToggleSubjectHousehold: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public transactionRegisterToggleSubject: BehaviorSubject<any> = new BehaviorSubject({ data: {}, open: false });
  public dataExtractionToggleSubject: BehaviorSubject<any> = new BehaviorSubject(false);
  public vaultSideNavToggleSubject: BehaviorSubject<any> = new BehaviorSubject(false);
  public sideNavToggleSubjectPositionReport: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public hiddenSectionToggleSubject: BehaviorSubject<any> = new BehaviorSubject({});

  templateRegisterData: BehaviorSubject<object> = new BehaviorSubject({});
  public isCreatingNewTemplate: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public toggleInboxSidenav: BehaviorSubject<boolean> = new BehaviorSubject(true);

  public reportManageMemberToggleSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);

  public toggleFormSetupSidenav(payload: any) {
    this.sideNavToggleSubjectFormSetup.next(payload);
  }

  public toggleLinkedTemplateSidenav(payload: any) {
    this.sideNavToggleSubjectLinkTemplate.next(payload);
  }

  public toggleTemplateSidenav(payload: boolean) {
    this.sideNavToggleSubjectTemplate.next(payload);
  }

  public toggleHouseholdSidenav(payload: any) {
    this.sideNavToggleSubjectHousehold.next(payload);
  }

  public toggleHiddenSectionSidenav(payload: any) {
    this.hiddenSectionToggleSubject.next(payload);
  }
  public toggleTransactionRegisterSidenav(payload: any) {
    this.transactionRegisterToggleSubject.next(payload);
  }

  public togglePositionReportSidenav(payload: boolean) {
    this.sideNavToggleSubjectPositionReport.next(payload);
  }

  public toggleDataExtractionToggleSubject(payload: boolean) {
    this.dataExtractionToggleSubject.next(payload);
  }
  public toggleVaultSideNavToggleSubject(payload: boolean) {
    this.vaultSideNavToggleSubject.next(payload);
  }

  public handleTemplateRegisterData(payload: object) {
    this.templateRegisterData.next(payload);
  }

  public fetchTransactionCountData(payload: boolean) {
    this.updateTransactionCountData.next(payload);
  }

  public fetchReportTransactionCountData(payload: boolean) {
    this.updateReportTransactionCountData.next(payload);
  }

  public handleToggleInboxSidenav(payload: boolean) {
    this.toggleInboxSidenav.next(payload);
  }

  public familyTreeSidenavToggleSubject: BehaviorSubject<{ event: boolean; familyTreeId: string }> = new BehaviorSubject({
    event: false,
    familyTreeId: null,
  });
  public toggleFamilyTreeSidenav(payload: any) {
    this.familyTreeSidenavToggleSubject.next(payload);
  }

  public secondSideNavToggleSubject: BehaviorSubject<any> = new BehaviorSubject(true);
  public isClose(payload) {
    this.secondSideNavToggleSubject.next(payload);
  }
  public checklistSidenavToggleSubject: BehaviorSubject<any> = new BehaviorSubject(true);
  public toggleSideNav(payload) {
    this.checklistSidenavToggleSubject.next(payload);
  }

  public manageTagsSidenavToggleSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public toggleManageTagsSideNav(payload) {
    this.manageTagsSidenavToggleSubject.next(payload);
  }

  public emailSettingsSidenavToggleSubject: BehaviorSubject<any> = new BehaviorSubject({ event: false, is_workspace: false, routeId: null });
  public toggleEmailSettingsSideNav(payload) {
    this.emailSettingsSidenavToggleSubject.next(payload);
  }

  public enableEmailCopyIdSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public toggleEnableEmailCopyId(payload) {
    this.enableEmailCopyIdSubject.next(payload);
  }

  public notifyInboxRightSidebarEvent: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public toggleNotifyInboxRightSidebarEvent(payload) {
    this.notifyInboxRightSidebarEvent.next(payload);
  }

  public toggleCreatingNewTemplate(payload: boolean) {
    this.isCreatingNewTemplate.next(payload);
  }

  public toggleReportManageMember(payload: boolean) {
    this.reportManageMemberToggleSubject.next(payload);
  }

  public notifyToUpdateFamilyTreeRelationship: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public toggleNotifyToUpdateFamilyTreeRelationship(payload) {
    this.notifyToUpdateFamilyTreeRelationship.next(payload);
  }

  // Folder selection observers for template filtering
  public currentFolderSubject: BehaviorSubject<{ folderName: string }> = new BehaviorSubject({
    folderName: '',
  });

  public setCurrentFolder(folderData: { folderName: string }) {
    this.currentFolderSubject.next(folderData);
  }

  public getCurrentFolder(): Observable<{ folderName: string }> {
    return this.currentFolderSubject.asObservable();
  }

  private rolePlayersStateMap = new Map<string, any>();
  public rolePlayersRegisterToggleSubject: BehaviorSubject<any> = new BehaviorSubject({ open: false, data: {}, refresh: false, templateId: null });
  public toggleRolePlayersRegisterSidenav(payload: any, templateId: string) {
    this.rolePlayersStateMap.set(templateId, payload);
    this.rolePlayersRegisterToggleSubject.next({ ...payload, templateId: templateId || null });
  }

  getRolePlayersState(templateId: string) {
    return this.rolePlayersStateMap.get(templateId) || { open: false, data: {}, refresh: false };
  }

  clearRolePlayersState(templateId: string) {
    this.rolePlayersStateMap.delete(templateId);
  }

  public rolePlayersRegisterFromResolveItemsSubject: BehaviorSubject<any> = new BehaviorSubject({ open: false, data: {}, refresh: false });
  public toggleRolePlayersRegisterFromResolveSidenav(payload: any) {
    this.rolePlayersRegisterFromResolveItemsSubject.next(payload);
  }

  getTemplateCategories(): Observable<any[]> {
    return this.http.get<any>('../../../../../assets/json/templatecategories.json').pipe(
      map((val) => {
        let categoriesList = [];
        categoriesList = val;
        // for (var key of Object.keys(val)) {
        //   categoriesList.push({ category_id: key, category_name: val[key] });
        // }
        return categoriesList;
      })
    );
  }

  getformSetupList(): Observable<any[]> {
    return this.http.get<any>('../../../../../assets/json/form-setup.json').pipe(
      map((val) => {
        return val;
      })
    );
  }

  getLocationItemsFromTrash() {
    const url = `api/common/trash/location`;
    return this.httpService.get(url).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        }
      })
    );
  }
  restoreLocationItemsFromTrash(payload) {
    const url = `api/common/restore-from-trash`;
    return this.httpService.post(url, payload).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response;
        }
      })
    );
  }
  deleteLocationItemsFromTrash(userId, id) {
    return this.httpService.delete<any>(`api/vault/vault-user-location/${userId}/${id}`).pipe(
      map((response) => {
        if (response.status == 200) {
          return response;
        } else {
          return response;
        }
      })
    );
  }
  public passDataToLocationTemplate(data: unknown) {
    this.locationTemplateDataSubject.next(data ?? undefined);
  }

  calculateNextDate(newDate, days, type, add = false) {
    days = +days;
    const date = new Date(newDate);
    if (add) {
      if (type == 'day') {
        date.setDate(date.getDate() + days);
      } else if (type == 'month') {
        date.setMonth(date.getMonth() + days);
      } else if (type == 'quarter') {
        const qDays = days * 3;
        date.setMonth(date.getMonth() + qDays);
      } else {
        date.setFullYear(date.getFullYear() + days);
      }
    } else {
      if (type == 'day') {
        date.setDate(date.getDate() - days);
      } else if (type == 'month') {
        date.setMonth(date.getMonth() - days);
      } else if (type == 'quarter') {
        const qDays = days * 3;
        date.setMonth(date.getMonth() - qDays);
      } else {
        date.setFullYear(date.getFullYear() - days);
      }
    }
    return date;
  }
  getRolePlayersJsonData(): Observable<any> {
    const url = `api/vault/vault-user-form-role-players-config`;
    return this.httpService.get<any>(url, null, loaderTypes.mainAnimation).pipe(
      map((response: any) => {
        if (response.status == 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }
  getProfessionalCookie() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith('professional=')) {
        return cookie.substring('professional='.length);
      }
    }
    return null; // Return null if the cookie is not found
  }

  gettcCodeCookie() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith('tcCode=')) {
        return cookie.substring('tcCode='.length);
      }
    }
    return null; // Return null if the cookie is not found
  }

  moveInboxToTrash(request) {
    return this.httpService.post(this.moveToTrashApi, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  restoreInboxFromTrash(request) {
    return this.httpService.post(this.restoreFromTrash, request).pipe(
      map((response: any) => {
        if (response.status === 200) {
          return response.data;
        } else {
          return response;
        }
      })
    );
  }

  ngOnDestroy() {
    this.distributionRegisterToggleSubject.complete();
  }
}
